// ─────────────────────────────────────────────────────────────
// photos.js — Gallery data (v2 · people-forward)
//
// Sections match the v2 nav: Portraits · Events · Nature
// Nature combines Wildlife + Landscape into one browsable gallery.
//
// Photo object shape:
//   src      — path to image in /public/Pictures/
//   alt      — descriptive alt text (SEO + a11y)
//   filter   — must match one of the strings in the filters array
//   caption  — optional hover caption (leave blank to omit)
//   width    — natural image width  (helps browser reserve space)
//   height   — natural image height (helps browser reserve space)
// ─────────────────────────────────────────────────────────────


// ── PORTRAITS ────────────────────────────────────────────────
export const PORTRAIT_FILTERS = ['All', 'People', 'Pets'];

export const PORTRAIT_PHOTOS = [
  {
    src: '/Pictures/Portraits/champagnetalk.jpg',
    alt: '',
    filter: 'People',
    caption: '',
    width: 3475,
    height: 5212,
  },
  {
    src: '/Pictures/Portraits/Diego-01223.jpeg',
    alt: '',
    filter: 'People',
    caption: '',
    width: 3375,
    height: 5853,
  },  
  {
    src: '/Pictures/Portraits/MKT07810.jpg',
    alt: '',
    filter: '',
    caption: '',
    width: 3457,
    height: 5185,
  },
  {
    src: '/Pictures/Portraits/MKT02057.jpeg',
    alt: '',
    filter: '',
    caption: '',
    width: 3930,
    height: 5896,
  },
  {
    src: '/Pictures/Portraits/MKT07229.jpeg',
    alt: '',
    filter: 'People',
    caption: '',
    width: 3644,
    height: 5552,
  },    
  {
    src: '/Pictures/Portraits/MKT06829.jpeg',
    alt: '',
    filter: '',
    caption: '',
    width: 3121,
    height: 3901,
  },
  {
    src: '/Pictures/Portraits/MKT07061.jpeg',
    alt: '',
    filter: 'People',
    caption: '',
    width: 4000,
    height: 6000,
  },  
  {
    src: '/Pictures/Portraits/MKT07045.jpeg',
    alt: '',
    filter: '',
    caption: '',
    width: 3198,
    height: 4797,
  },
  {
    src: '/Pictures/Portraits/MKT08396.jpeg',
    alt: '',
    filter: 'Pets',
    caption: '',
    width: 4000,
    height: 6000,
  },
/*  {
    src: '/Pictures/Portraits/MKT01703.jpeg',
    alt: '',
    filter: 'Pets',
    caption: '',
    width: 2700,
    height: 4050,
  }, */
];


// ── EVENTS ───────────────────────────────────────────────────
export const EVENTS_FILTERS = ['All'];

export const EVENTS_PHOTOS = [
  {
    src: '/Pictures/Events/bannerfamily.jpg',
    alt: '',
    filter: '',
    caption: '',
    width: 6295,
    height: 4197,
  },
  {
    src: '/Pictures/Events/conversational.jpg',
    alt: '',
    filter: '',
    caption: '',
    width: 5388,
    height: 3592,
  },
  {
    src: '/Pictures/Events/crowdspeech.jpg',
    alt: '',
    filter: '',
    caption: '',
    width: 6712,
    height: 4475,
  },
  {
    src: '/Pictures/Events/gradtoast.jpg',
    alt: '',
    filter: '',
    caption: '',
    width: 3353,
    height: 5029,
  },
];


// ── NATURE (Wildlife + Landscape combined) ───────────────────
// Reorder freely — filter: 'Wildlife' or 'Landscape' controls the tab filter,
// but the order here is the order they appear in the gallery.
export const NATURE_FILTERS = ['All', 'Wildlife', 'Landscape'];

export const NATURE_PHOTOS = [
  {
    src: '/Pictures/Wildlife/MKT00494.jpg',
    alt: '',
    filter: 'Wildlife',
    caption: '',
    width: 4000,
    height: 6000,
  },
    {
    src: '/Pictures/Landscape/MKT06061.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 4000,
    height: 6000,
  },
  {
    src: '/Pictures/Landscape/IMG_4464.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 4095,
    height: 1720,
  },
  {
    src: '/Pictures/Wildlife/MKT05763.jpeg',
    alt: '',
    filter: 'Wildlife',
    caption: '',
    width: 4000,
    height: 6000,
  },
  {
    src: '/Pictures/Landscape/MKT02235.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 5925,
    height: 3950,
  },
  {
    src: '/Pictures/Landscape/MKT02315.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 4000,
    height: 6000,
  },
  {
    src: '/Pictures/Wildlife/MKT03671.jpeg',
    alt: '',
    filter: 'Wildlife',
    caption: '',
    width: 2257,
    height: 3385,
  },
   {
    src: '/Pictures/Wildlife/MKT03585.jpeg',
    alt: '',
    filter: 'Wildlife',
    caption: '',
    width: 5672,
    height: 3268,
  },
  {
    src: '/Pictures/Landscape/MKT05641.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 3828,
    height: 4785,
  },
  {
    src: '/Pictures/Wildlife/MKT00838a.jpg',
    alt: '',
    filter: 'Wildlife',
    caption: '',
    width: 4002,
    height: 5003,
  },
  {
    src: '/Pictures/Landscape/IMG_5142.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 3024,
    height: 3024,
  },
  {
    src: '/Pictures/Wildlife/MKT01607.jpeg',
    alt: '',
    filter: 'Wildlife',
    caption: '',
    width: 2822,
    height: 2822,
  },
  {
    src: '/Pictures/Landscape/MKT06088.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 3593,
    height: 4790,
  },
  {
    src: '/Pictures/Landscape/MKT02895-6.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 4000,
    height: 6000,
  },
  {
    src: '/Pictures/Landscape/MKT02874-5.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 4000,
    height: 6000,
  },
/*  {
    src: '/Pictures/Wildlife/MKT05746.jpeg',
    alt: '',
    filter: 'Wildlife',
    caption: '',
    width: 6000,
    height: 4000,
  },
  {
    src: '/Pictures/Wildlife/MKT03128-1.jpeg',
    alt: '',
    filter: 'Wildlife',
    caption: '',
    width: 5000,
    height: 2001,
  },
  {
    src: '/Pictures/Landscape/MKT06870.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 3862,
    height: 4969,
  }, */
  {
    src: '/Pictures/Landscape/MKT07033.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 4000,
    height: 6000,
  },
  {
    src: '/Pictures/Landscape/MKT04121.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 6000,
    height: 4000,
  },
  {
    src: '/Pictures/Landscape/MKT09922.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 5959,
    height: 2155,
  },
  {
    src: '/Pictures/Landscape/MKT09766-2.jpeg',
    alt: '',
    filter: 'Landscape',
    caption: '',
    width: 4000,
    height: 6000,
  },
];


// ── PRINTS ───────────────────────────────────────────────────
export const PRINTS_FILTERS = ['All', 'Nature', 'Portraits'];

export const PRINTS_PHOTOS = [
  // Reference photos available as fine art prints
];
